import { Form } from '@calendly/form';
import { usePageTitle } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { saveOrgEventTypeSettings } from 'actions/current_organization';
import { orgEventTypeSettingsSelector } from 'selectors/current_organization';
import { Description, Question } from '../styles';
import { FormContent } from './form_content';
const customDescriptionCss = "cqee1ug";
const CustomDescription = forwardRef((props, ref) => <Description ref={ref} {...props} className={classNames(customDescriptionCss, props.className)} />);
export const SharedEventTypes = () => {
  const dispatch = useDispatch();
  const settings = useSelector(orgEventTypeSettingsSelector);
  const pageTitle = `${I18n.t('publisher.admin.permissions.tabs.event_types')} - ${I18n.t('publisher.admin.permissions.title')}`;
  usePageTitle(pageTitle);
  return <>
      <CustomDescription>
        {I18n.t('publisher.organization_settings.shared_event_types.description')}
      </CustomDescription>
      <Question>
        {I18n.t('publisher.organization_settings.shared_event_types.question')}
      </Question>
      <Form initialValues={settings} onSubmit={newSettings => dispatch(saveOrgEventTypeSettings(newSettings))}>
        <FormContent />
      </Form>
    </>;
};

require("./shared_event_types.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./shared_event_types.js");